import React, { useState, useRef ,useEffect } from "react"
import { withRouter } from "react-router-dom"
//import { useSelector, connect } from "react-redux"
import MetaTags from "react-meta-tags"
import { useSelector, connect, useDispatch } from "react-redux"
import Select from "react-select"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Button,
  // Table,
  Container,
  Card,
  CardBody,
  Label,
  Input,
  CardHeader,
} from "reactstrap"
//import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as ecFollowupAction from "../../store/Zm9sbG93dXBVcGxvYWQ/actions"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import { isEmpty } from "lodash"
import Breadcrumbs from "components/Common/Breadcrumb"
import PropTypes from "prop-types"
import api from "helpers/Api"
 import moment from "moment"
import SimpleReactValidator from "simple-react-validator"

const FollowupUpdate = () => {
  const specificDispatch = useDispatch()
  const title = "Followup Upload"
  useEffect(() => {
    specificDispatch(ecFollowupAction.loadRecordsMetaData())
    setFollowUpData({
      followUpDate: currentDate,
      time: currentTime,
    })
   
  }, [])
  const ecUpdate = useSelector((state) => state.followupUpdate)
  const {ec_followup_list = [] , recordsMetaData = {}} = ecUpdate
  console.log(ecUpdate, "ecUpdate")
  const [leadData, setLeadData] = useState({
    leadNo: ""
  })
  const handleChange = (e) => {
    setLeadData({ ...leadData, [e.target.name]: e.target.value })
  }
  const [viewTable, setViewTable] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const currentDate = moment().format("YYYY-MM-DD")
  // console.log(currentDate, "currentDate")
  const currentTime = moment().format("LT")
  const applyfilter = () => {
    var searchLead =
      leadData && !isEmpty(leadData) ? leadData.leadNo : ""
    var searchValue = {}
    searchValue.status = "active"
    if (searchLead) {
      searchValue.leadNo = searchLead
    }
    if (!isEmpty(leadData.leadNo)) {
      setViewTable(true)
      addFollowupModalDetails()
      specificDispatch(ecFollowupAction.loadEcFollowupList(searchValue))
    }
    setBtnLoader(true) 
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  
  const leadId = ec_followup_list && !isEmpty(ec_followup_list) && ec_followup_list.length>0?
  ec_followup_list.map(m=>m._id).join():""
  const resetForm = () => {
    setLeadData({
      leadNo: ""
    })
    setViewTable(false)
  }
  //followup modal data
  const [followUpData, setFollowUpData] = useState({
    followUpDate: "",
    time: "",
    reachStatus: "",
    followUpRemarks: "",
    followupMode: "",
    followupStatus: "",
    attachment: [],
  })
  //handle change

  const handleFollowUpChange = async (e) => {
    setFollowUpData({ ...followUpData, [e.target.name]: e.target.value })
  }
  //folowwup dropdown initial state
  const [followUpMode, setFollowUpMode] = useState([])


  const [followUpStatus, setFollowUpStatus] = useState([])

  const [uploadInput, setUploadInput] = useState([])

  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")
  //Attachment Change

  const uploadChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadInput(teamUploadValue)
          }
        })
      }
    }
  }
  const addFollowupModalDetails = () => {
   
    setFollowUpData({
      followUpDate: currentDate,
      time: currentTime,
    })
    setFollowUpMode([])
    setFileName("")
    setFileLength("")
    setFollowUpStatus([])
    setUploadInput([])
    simpleValidator.current.hideMessages()
  }
  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate] = useState()

  //Add EC FOllowup
  const addFollowup = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      let ecFollowupData = {
        leadId: leadId,
        followupDate: followUpData.followUpDate,
        time: followUpData.time,
        followupMode: followUpMode.value,
        reachStatus: "Completed",
        followupRemarks: followUpData.followUpRemarks,
        attachment: uploadInput.map((data) => data),
        followupReason: followUpStatus.value,
      }
      console.log(ecFollowupData)
      specificDispatch(ecFollowupAction.addEcFollowup(ecFollowupData))
      setTimeout(() => {
        // setIsEdit(false)
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
       setViewTable(true)
        //specificDispatch(ecFollowupAction.loadEcFollowupList(id))
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Lead No"}>
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          name="leadNo"
                          value={leadData.leadNo}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Lead No"
                        />
                      </Col>
                      <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                        <div style={{ marginTop: "27px", float: "left" }}>
                          <Button
                            type="button"
                            onClick={() => applyfilter()}
                            className="btn btn-info btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-search label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Search"
                            )}{" "}
                          </Button>

                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>

                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {viewTable && <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardHeader style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "18px",
                }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "18px",
                      padding: "6px",
                      borderRadius: "4px",
                      minWidth: "150px",
                      textAlign: "center",
                      marginRight: "10px",
                      boxShadow: "2px 4px 6px #6f5c5c",
                      cursor: "pointer",
                      textTransform: "uppercase",
                    }}
                  >
                    {leadData.leadNo}
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col lg="12" md="12" sm="6" xs="6" className="d-flex flex-row">
                      <p className="quote-head">
                        EC Followup
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip placement="right" target="quoteInfo1">
                            EC Followup
                          </UncontrolledTooltip>
                        </span>
                      </p>

                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={followUpData.followUpDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={followUpData.time}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="followUpMode"
                        value={followUpMode}
                        onChange={(e) => setFollowUpMode(e)}
                        options={
                          recordsMetaData ? recordsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpMode",
                          followUpMode,
                          "required"
                        )}
                      </div>
                    </Col>


                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="uploadInput"
                          accept="application/pdf, audio/mp3 , image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => uploadChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {fileLength ? fileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {fileName ? fileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "Attachment",
                          uploadInput,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Reason"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                         type="text"
                        name="followUpStatus"
                        value={followUpStatus}
                        onChange={(e) => setFollowUpStatus(e)}
                         options={recordsMetaData.followUpReasonOptions}
                        placeholder="Select Follow Up Reason"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpStatus",
                          followUpStatus,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col md="12" xl="12" lg="12" className="mt-4">
                      <div style={{ float: "right" }} className="d-flex flex-row">
                        <Button
                          type="button"
                          // variant="primary"
                          className="btn btn-danger"
                          onClick={() => {
                            setViewTable(false)
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          type="button"
                          variant="primary"
                          className="btn btn-success mx-2"
                          onClick={(e) => {
                            addFollowup(e)
                          }}
                        >
                          Submit
                        </Button>

                      </div>
                    </Col>
                  </Row></CardBody></Card>
            </Col>
          </Row>}
        </Container>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

FollowupUpdate.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.array,
  location: PropTypes.array,
  modeMenu: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})
//FollowupUpdate
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FollowupUpdate)
)
